import Vue from 'vue';

export default class ListUtils {
  static loadItemsData (instance, config) {
    let loadedKey = config.loadedKey || 'loaded';
    let errorKey = config.errorKey || 'load_error';
    instance[loadedKey] = false;
    instance[errorKey] = false;

    instance.$http.post(config.endpoint, config.params).then(response => {
      instance[config.listField] = response.data.data;
      instance[loadedKey] = true;

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }
    }).catch(error => {
      console.error(error);
      instance[errorKey] = true;
      instance[loadedKey] = true;
    });
  }

  static removeItem (instance, config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: config.buttonOkText ? config.buttonOkText : 'Tak, usuń',
      cancelButtonText: 'Anuluj'
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              type: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.error(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              type: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.error(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else if (config.cancelAction) {
        config.cancelAction();
      }
    });
  }
}
